/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Store_Dry_GoodsInputs */

const en_store_dry_goods = /** @type {(inputs: Store_Dry_GoodsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dry goods`)
};

const de_store_dry_goods = /** @type {(inputs: Store_Dry_GoodsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trockenware`)
};

/**
* | output |
* | --- |
* | "Dry goods" |
*
* @param {Store_Dry_GoodsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const store_dry_goods = /** @type {((inputs?: Store_Dry_GoodsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Store_Dry_GoodsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_store_dry_goods(inputs)
	return en_store_dry_goods(inputs)
});